__turbopack_context__.v({
  "btn": "ReviewBlock-module-scss-module__eBWIgW__btn",
  "btn-next": "ReviewBlock-module-scss-module__eBWIgW__btn-next",
  "btn-prev": "ReviewBlock-module-scss-module__eBWIgW__btn-prev",
  "no-background": "ReviewBlock-module-scss-module__eBWIgW__no-background",
  "no-transition": "ReviewBlock-module-scss-module__eBWIgW__no-transition",
  "review-block": "ReviewBlock-module-scss-module__eBWIgW__review-block",
  "track": "ReviewBlock-module-scss-module__eBWIgW__track",
  "track-item": "ReviewBlock-module-scss-module__eBWIgW__track-item",
  "viewport": "ReviewBlock-module-scss-module__eBWIgW__viewport",
  "wrapper": "ReviewBlock-module-scss-module__eBWIgW__wrapper",
});
